import { CSSProperties, JSX, useEffect, useState } from "react";

interface MenuButtonProps {
  label: string;
  startIcon?: JSX.Element;
  variant?: "small" | "large";
  children?: JSX.Element | JSX.Element[];
}

export default function DropButton({
  label,
  startIcon,
  variant,
  children,
}: MenuButtonProps) {
  const [open, setOpen] = useState<boolean>(false);

  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      setVisible(true);
    } else {
      const timeout = setTimeout(() => setVisible(false), 200);
      return () => clearTimeout(timeout);
    }
  }, [open]);
  return (
    <div className="relative">
      {open && (
        <div
          onClick={() => setOpen(false)}
          className="fixed h-screen w-screen top-0 left-0 z-40"
        />
      )}

      <div
        className={`${variant === "small" ? "px-3 py-1 rounded-lg font-medium" : "px-4 py-3 rounded-xl font-semibold"} items-center text-h2 w-fit flex flex-row gap-4 hover:ring-2 hover:ring-neutral-300 border text-neutral-800 cursor-pointer`}
        onClick={() => setOpen(true)}
      >
        {startIcon} {label}
      </div>

      {open && (
        <div
          onClick={() => setOpen(false)}
          className={`
                                  ${visible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-10 scale-90"}

            absolute top-full transition-all duration-200  left-0 z-50 w-200 flex flex-col text-shadow_50 border-1 border-shadow_10 bg-white p-2 shadow-xl rounded-lg`}
        >
          {children}
        </div>
      )}
    </div>
  );
}
